module.exports = __webpack_public_path__ + "img/burger-menu-point.36e8a3a0.svg";